import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Ganda Sushi</title>
      </Helmet>

      <main className="bg-luxury-cream text-luxury-dark pt-40 pb-24">
        <section className="max-w-4xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="prose prose-gold max-w-none"
          >
            <h1 className="text-5xl font-serif text-luxury-gold mb-12 uppercase tracking-tight">Privacy Policy</h1>
            <p className="text-luxury-dark/60 italic mb-12 border-l-2 border-luxury-gold pl-6">Effective Date: January 27, 2025</p>

            <div className="space-y-12 text-luxury-dark/70 leading-relaxed font-light">
              <section>
                <h2 className="text-2xl font-serif text-luxury-dark mb-6">1. Information Collection</h2>
                <p>
                  At Ganda Sushi, we collect information that you provide directly to us during the course of your dining experience or digital interaction. This includes contact details for reservations, dietary preferences, and payment information.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-serif text-luxury-dark mb-6">2. Use of Information</h2>
                <p>
                  Your information is utilized solely to enhance your experience with us, process orders efficiently, and communicate relevant updates about our services. We maintain the highest standards of data integrity and confidentiality.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-serif text-luxury-dark mb-6">3. Data Security</h2>
                <p>
                  We implement sophisticated administrative and technical safeguards to protect your personal information. Your trust is paramount, and we treat your data with the same care we apply to our culinary crafts.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-serif text-luxury-dark mb-6">4. Contact</h2>
                <div className="p-8 bg-white border border-luxury-gold/10 rounded-sm shadow-sm">
                  <p className="font-serif text-luxury-gold text-lg">Ganda Sushi</p>
                  <p>80-08 Surrey Pl, Jamaica, NY 11432</p>
                  <p>Phone: (718) 380-1818</p>
                </div>
              </section>
            </div>
          </motion.div>
        </section>
      </main>
    </>
  );
};

export default PrivacyPolicy;